import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  loginApi,
  registerApi,
  ladeToken,
  ladeUser,
  speichereAuth,
  loescheAuth,
} from './authApi';

/**
 * Redux-Slice fuer die Benutzerverwaltung (Login/Registrierung).
 * Token und Userdaten werden im localStorage gespiegelt, damit die Anmeldung
 * einen Reload uebersteht.
 */

/** Liest die Fehlermeldung aus der API-Antwort (Feld `error`) heraus. */
const fehlerText = (err) =>
  err.response?.data?.error || 'Aktion fehlgeschlagen. Bitte erneut versuchen.';

export const login = createAsyncThunk('auth/login', async ({ username, password }, { rejectWithValue }) => {
  try {
    const daten = await loginApi(username, password);
    speichereAuth(daten);
    return daten;
  } catch (err) {
    return rejectWithValue(fehlerText(err));
  }
});

export const register = createAsyncThunk(
  'auth/register',
  async ({ username, email, password }, { rejectWithValue }) => {
    try {
      const daten = await registerApi(username, email, password);
      speichereAuth(daten);
      return daten;
    } catch (err) {
      return rejectWithValue(fehlerText(err));
    }
  }
);

const initialState = {
  token: ladeToken(),
  user: ladeUser(),
  status: 'idle', // idle | loading | succeeded | failed
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      loescheAuth();
      state.token = null;
      state.user = null;
      state.status = 'idle';
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    const erfolg = (state, action) => {
      state.status = 'succeeded';
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.error = null;
    };
    const start = (state) => {
      state.status = 'loading';
      state.error = null;
    };
    const fehler = (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    };
    builder
      .addCase(login.pending, start)
      .addCase(login.fulfilled, erfolg)
      .addCase(login.rejected, fehler)
      .addCase(register.pending, start)
      .addCase(register.fulfilled, erfolg)
      .addCase(register.rejected, fehler);
  },
});

export const { logout, clearError } = authSlice.actions;

export const selectIstAngemeldet = (state) => Boolean(state.auth.token);
export const selectAktuellerUser = (state) => state.auth.user;
export const selectAuthStatus = (state) => state.auth.status;
export const selectAuthError = (state) => state.auth.error;

export default authSlice.reducer;
